import React from "react";
import Accordion from "react-bootstrap/Accordion";
import PaginationModified from "../../data/PaginationModified";
import {
  convertStraight,
  convertThenFormat,
  convertTo12HourFormat,
  formatDateTime,
} from "../common-data/Converts";
import { CrossCircleIcon, XCircleIcon } from "../../images/icons/icons";

const DFPMLinksMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  isShowPmLink,
  isAdmin,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const planStatus = row?.status?.replace(/ /g, "_")?.toLowerCase();
          const isPT = row?.type === "addon_pt";
          const isDual = row?.payment_mode === "cash/online";
          const isPartial = row?.payment_mode === "partial";
          const isPending = row?.status === "pending";

          const handleCopyLink = async (event) => {
            event?.stopPropagation?.();

            if (row?.dynamic_link_url) {
              try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                  await navigator.clipboard.writeText(row.dynamic_link_url);
                } else {
                  const textArea = document.createElement("textarea");
                  textArea.value = row.dynamic_link_url;
                  textArea.style.position = "fixed";
                  textArea.style.left = "-999999px";
                  textArea.style.top = "-999999px";
                  document.body.appendChild(textArea);
                  textArea.focus();
                  textArea.select();

                  try {
                    document.execCommand("copy");
                  } catch (err) {
                    console.error("Fallback: Oops, unable to copy", err);
                  }

                  document.body.removeChild(textArea);
                }

                const toast = document.createElement("div");
                toast.textContent = "Link copied!";
                toast.style.cssText = `
                  position: fixed;
                  top: 20px;
                  right: 20px;
                  background: #379C00;
                  color: white;
                  padding: 12px 24px;
                  border-radius: 4px;
                  font-size: 14px;
                  z-index: 9999;
                  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                  animation: fadeInOut 2s ease-in-out;
                `;

                const style = document.createElement("style");
                style.textContent = `
                  @keyframes fadeInOut {
                    0% { opacity: 0; transform: translateY(-20px); }
                    15% { opacity: 1; transform: translateY(0); }
                    85% { opacity: 1; transform: translateY(0); }
                    100% { opacity: 0; transform: translateY(-20px); }
                  }
                `;
                document.head.appendChild(style);
                document.body.appendChild(toast);

                setTimeout(() => {
                  toast.remove();
                  style.remove();
                }, 2000);
              } catch (err) {
                console.error("Failed to copy link:", err);
              }
            }
          };

          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="log-card-top">
                  <h3 className="lead-name name-checkbox">
                    {row?.user_name || "NA"}
                  </h3>

                  {isShowPmLink && (
                    <span
                      className={`lead-type icon`}
                      style={{ background: "transparent" }}
                    >
                      {row?.payment_link ? (
                        <a
                          className=""
                          rel="noreferrer"
                          target="_blank"
                          href={row.payment_link}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-box-arrow-up-right"
                            viewBox="0 0 16 16"
                            style={{
                              cursor: "pointer",
                              opacity: 1,
                            }}
                          >
                            <path
                              fillRule="evenodd"
                              d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                            />
                            <path
                              fillRule="evenodd"
                              d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                            />
                          </svg>
                        </a>
                      ) : (
                        <CrossCircleIcon />
                      )}
                    </span>
                  )}
                </div>

                <div className="lead-multi-value-cols px20px">
                  <div className="label-value">
                    <span className="value">{row?.user_mobile || ""}</span>
                  </div>

                  <div className="label-value">
                    <span className="value lowercase">
                      {row?.user_email || ""}
                    </span>
                  </div>

                  <div className="label-value">
                    <span className="value" style={{ textAlign: "start" }}>
                      {row?.gym_name || "NA"}
                    </span>
                  </div>

                  <div className="label-value">
                    <span className="label">Payment Status</span>
                    <span
                      className="value"
                      style={{
                        background:
                          planStatus === "completed"
                            ? "#379C00"
                            : planStatus === "pending"
                            ? "#EB8317"
                            : "#D90000",
                        color: "#fff",
                        padding: "5px",
                        borderRadius: "4px",
                      }}
                    >
                      {!isShowPmLink && planStatus === "pending"
                        ? "Link Sent"
                        : row?.status || "NA"}
                    </span>
                  </div>
                </div>

                {/* <div className="log-card-top">
                  <div
                    className="profile-name-number"
                    style={{
                      columnGap: "0",
                      height: "auto",
                    }}>
                    <div className="name-number">
                      <h3 className="lead-name">{row?.user_name || "NA"}</h3>
                      <p className="number underline">
                        {row?.user_mobile || "NA"}
                      </p>
                      {row?.user_email ? (
                        <span className="value email semi-bold underline">
                          {row?.user_email || "NA"}
                        </span>
                      ) : null}
                      <p className="number">{row?.gym_name || ""}</p>
                    </div>
                  </div>
                </div> */}

                <div className="all-followuo-info-container pt-track-acc">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header style={{ padding: "0 10px 10px 10px" }}>
                        {/* Show More */}
                        <div className="heade-info">
                          <span className="title">date added</span>
                          <span className="value">
                            {row?.date_added
                              ? formatDateTime(row.date_added)
                              : "-"}
                          </span>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value">
                            <span className="label">gender</span>
                            <span className="value">{row?.gender || "NA"}</span>
                          </div>

                          <div className="label-value">
                            <span className="label">created by</span>
                            <span className="value">
                              {row?.created_by_name || "NA"}
                              <br />
                              <small style={{ textTransform: "lowercase" }}>
                                {row?.created_by_mobile || ""}
                                <br />
                                {row?.created_by_email || ""}
                              </small>
                            </span>
                          </div>

                          {/* <div className="label-value">
                            <span className="label">Payment Status</span>
                            <span
                              className="value"
                              style={{
                                background:
                                  planStatus === "completed"
                                    ? "#379C00"
                                    : planStatus === "pending"
                                    ? "#EB8317"
                                    : "#D90000",
                                color: "#fff",
                                padding: "5px",
                                borderRadius: "4px",
                              }}>
                              {row?.status || "NA"}
                            </span>
                          </div> */}

                          <div className="label-value">
                            <span className="label">Plan Type</span>
                            <span className="value">{row?.type || "NA"}</span>
                          </div>

                          <div className="label-value">
                            <span className="label">Plan name</span>
                            <span className="value">
                              {row?.plan_name || "NA"}
                            </span>
                          </div>

                          {isPT && (
                            <>
                              <div className="label-value">
                                <span className="label">PT sessions</span>
                                <span className="value">
                                  {row?.n_session || 0} sessions for{" "}
                                  {row?.duration || 0} days
                                </span>
                              </div>

                              <div className="label-value">
                                <span className="label">PT trainer</span>
                                <span className="value">
                                  {row?.trainer_name || "NA"}
                                </span>
                              </div>

                              <div className="label-value">
                                <span className="label">slot</span>
                                <span className="value">
                                  {row?.start_time
                                    ? convertTo12HourFormat(row.start_time)
                                    : ""}{" "}
                                  -{" "}
                                  {row?.end_time
                                    ? convertTo12HourFormat(row.end_time)
                                    : ""}
                                </span>
                              </div>
                            </>
                          )}

                          <div className="label-value">
                            <span className="label">Plan Price</span>
                            <span className="value">
                              ₹{convertThenFormat(row?.plan_price || 0)}
                            </span>
                          </div>

                          {!isPT && (
                            <div className="label-value">
                              <span className="label">extend days</span>
                              <span className="value">
                                {row?.extend_days || 0}
                              </span>
                            </div>
                          )}

                          <div className="label-value">
                            <span className="label">Plan duration</span>
                            <span className="value">
                              {row?.start_date
                                ? convertStraight(row.start_date)
                                : "-"}{" "}
                              TO{" "}
                              {row?.expire_date
                                ? convertStraight(row.expire_date)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">payment mode</span>
                            <span
                              className={`value ${isPartial ? "link" : ""}`}
                              onClick={
                                isPartial
                                  ? () =>
                                      setModValues((prevs) => ({
                                        ...prevs,
                                        isModOpen: true,
                                        modName: "partial_details",
                                        rowData: row,
                                      }))
                                  : null
                              }
                            >
                              {row?.payment_mode || "NA"}
                            </span>
                          </div>

                          {isDual && (
                            <>
                              <div className="label-value">
                                <span className="label">cash amount</span>
                                <span className="value">
                                  ₹{convertThenFormat(row?.cash_amount || 0)}
                                </span>
                              </div>

                              <div className="label-value">
                                <span className="label">online amount</span>
                                <span className="value">
                                  ₹{convertThenFormat(row?.online_amount || 0)}
                                </span>
                              </div>
                            </>
                          )}

                          {isPartial && (
                            <>
                              <div className="label-value">
                                <span className="label">
                                  first payment mode
                                </span>
                                <span className="value">
                                  {row?.first_payment_mode || "NA"}
                                </span>
                              </div>
                            </>
                          )}

                          {/* <div className="label-value">
                            <span className="label">date added</span>
                            <span className="value">
                              {row?.date_added
                                ? formatDateTime(row.date_added)
                                : "-"}
                            </span>
                          </div> */}

                          {isAdmin && (
                            <div className="label-value">
                              <span className="label">
                                website payment link
                              </span>

                              <span className="value icon mt15">
                                {row?.dynamic_link_url ? (
                                  <a
                                    className=""
                                    rel="noreferrer"
                                    target="_blank"
                                    href={row.dynamic_link_url}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-box-arrow-up-right"
                                      viewBox="0 0 16 16"
                                      style={{
                                        cursor: "pointer",
                                        opacity: 1,
                                      }}
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                                      />
                                    </svg>
                                  </a>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-box-arrow-up-right"
                                    viewBox="0 0 16 16"
                                    style={{
                                      cursor: "not-allowed",
                                      opacity: 0.5,
                                    }}
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                                    />
                                  </svg>
                                )}
                              </span>
                            </div>
                          )}

                          <div className="label-value">
                            <span className="label">app payment link</span>

                            <span className="value icon mt15">
                              {row?.dynamic_link_url ? (
                                <>
                                  {isPending ? (
                                    <button
                                      type="button"
                                      onClick={handleCopyLink}
                                      className="btn btn-outline-primary capitalize"
                                    >
                                      Click to Copy
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      disabled
                                      className="btn btn-outline-primary capitalize"
                                      style={{
                                        cursor: "not-allowed",
                                        opacity: 0.5,
                                      }}
                                    >
                                      {planStatus}
                                    </button>
                                  )}
                                </>
                              ) : (
                                <XCircleIcon />
                              )}
                            </span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default DFPMLinksMobile;
